const nf = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 3 });

export function formatScope(q: { scopeQty: number; uom: string }): string {
  return `${nf.format(q.scopeQty)} ${q.uom}`;
}

/** Positive finite number or null. Backend requires scopeQty > 0 (min 0.001). */
export function parseScopeInput(raw: string): number | null {
  const n = Number(raw.trim());
  return Number.isFinite(n) && n > 0 ? n : null;
}
